import { useEffect } from 'react'
import type { PropsWithChildren } from 'react'
import { useAuthStore } from '../stores/auth'
import { http } from '../api/client'
import { Endpoints } from '../api/endpoints'
import type { Role } from './roles'

interface MeResponse {
  id:        string
  firstName: string
  lastName:  string
  tenantId:  string
  role:      string
}

export function AuthProvider({ children }: PropsWithChildren) {
  const { setUser, setLoading } = useAuthStore()

  useEffect(() => {
    http.get<MeResponse>(Endpoints.auth.me)
      .then(me => setUser({
        id:       me.id,
        name:     `${me.firstName} ${me.lastName}`,
        role:     (me.role ?? 'TenantMember') as Role,
        tenantId: me.tenantId,
      }))
      .catch(() => setUser(null))
      .finally(() => setLoading(false))
  }, [setUser, setLoading])

  return <>{children}</>
}